import { IGamesStore } from '../store';

import api, { request } from '../../../../api';
import { IStore } from '../../../index';

export const setScorer = async (
  state: IStore,
  groupId: number,
  scorer: number
): Promise<{ games?: IGamesStore }> => {
  const response = await request.patch(api.group(groupId), { scorer });

  const updatedGame = {
    ...Object.values(state.games).find(g => g.group.id === response.id),
    group: response
  };

  return {
    games: {
      ...state.games,
      [updatedGame.id]: updatedGame
    }
  };
};
